import { Provider } from '@angular/core';
import { UuidGenerationService } from './uuid-generation.service';

export function provideUuidGeneration(): Provider[] {
  return [UuidGenerationService];
}
